<template>
  <div>
    <excelUploadCard
      urlItem=""
      :title="$t('Upload household list')"
      :loadbtn="$t('Select household list')"
    />
    <excelUploadCard
      urlItem=""
      :title="$t('Upload policies')"
      :loadbtn="$t('Select policies')"
    />
  </div>
</template>
  
  <script>
import excelUploadCard from "../shared/emailMarketing/ExcelUploadCard.vue";
export default {
  components: {
    excelUploadCard,
  },
};
</script>
  
  <style>
</style>